module.exports = __webpack_public_path__ + "static/media/geolocalizacion1.ba0ad3c5.svg";